"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceMode = void 0;
var ServiceMode;
(function (ServiceMode) {
    ServiceMode["cateringDelivery"] = "CATERING_DELIVERY";
    ServiceMode["cateringPickup"] = "CATERING_PICKUP";
    ServiceMode["curbside"] = "CURBSIDE";
    ServiceMode["delivery"] = "DELIVERY";
    ServiceMode["driveThru"] = "DRIVE_THRU";
    ServiceMode["eatIn"] = "EAT_IN";
    ServiceMode["tableService"] = "TABLE_SERVICE";
    ServiceMode["takeout"] = "TAKEOUT";
})(ServiceMode || (exports.ServiceMode = ServiceMode = {}));
//# sourceMappingURL=service-mode.js.map